import { render } from "./S177816.vue?vue&type=template&id=7de5c3f6"
const script = {}
script.render = render

export default script